import {
  AccessState,
  BreadcrumbV2Object,
  Tag,
} from '@elsevier-health/osmosis-shared/types/learn';

export enum LibraryCheckboxState {
  UNCHECKED = 0,
  CHECKED = 1,
}

export type LibraryCheckbox = {
  nodeID: number;
  state: LibraryCheckboxState;
};

export type LearnWatchedItems = {
  mediaID: number;
  percent: number;
  lastTime: number;
};

export type LibraryTopicResource = {
  hint: string;
  name: string;
  src: string;
};

export type LibraryTopicGroupPage = {
  accessState: AccessState;
  breadcrumbsv2?: BreadcrumbV2Object[];
  completed: number;
  duration: string;
  durationSeconds: number;
  learnNodeID: number;
  pageType: string;
  resources: LibraryTopicResource[];
  thumbnail: string;
  title: string;
  trackingSource: string;
  url: string;
  watchedPercent: string;
  mediaNodeID: number;
  tags: Tag[];
};

export type LibraryTopicGroup = {
  count: number;
  hash: string;
  pages: LibraryTopicGroupPage[];
  title: string;
};

export type LibraryTopic = {
  addToPlaylist: { videos: number[]; trackingSource: string };
  count: number;
  firstVideo: string;
  groups: LibraryTopicGroup[];
  groupsCount: number;
  hash: string;
  pageCount: number;
  parent: string;
  title: string;
};

export type LibraryTopicLevel = {
  content?: string[];
  counts?: number[];
  hasContent?: boolean;
  hash: string;
  percentagePer?: number;
  title: string;
  toggleTopics?: () => void;
  isTopicsOpen?: boolean;
  bsContent?: string;
};

export type TypeForTopic = {
  args: LibraryTopic;
  block: string;
};
export type TypeForLevelTopic = {
  args: LibraryTopicLevel;
  block: string;
};

export type MixedTopicsType = TypeForTopic | TypeForLevelTopic;

export type LoggedInLibraryHeaderBlock = {
  args: {
    icon: string;
    levelOneTitle: string;
    selected: string;
    shareData: {
      include: string[];
      withText: boolean;
    };
  };
  block: string;
};

export type LoggedInLibrarySidenavBlockContentContain = {
  contains: { displayName: string; name: string; type: string }[];
  containsCount: number;
  displayName: string;
  link: string;
  name: string;
  sectionID: number;
  type: string;
};

export type LoggedInLibrarySidenavBlockContent = {
  contains: LoggedInLibrarySidenavBlockContentContain[];
  displayName: string;
  link: string;
  name: string;
  sectionID: number;
  type: string;
  label?: string;
};

export type LoggedInLibrarySidenavBlock = {
  args: {
    bindID: string;
    contents: LoggedInLibrarySidenavBlockContent[];
  };
  block: string;
};

export type LoggedInLibraryData = {
  url: string;
  client: string;
  description: string;
  label: string;
  header: {
    path: string;
    blocks: LoggedInLibraryHeaderBlock[];
  };
  image: string;
  modified: string;
  sidenav: {
    path: string;
    blocks: LoggedInLibrarySidenavBlock[];
  };
  template: string;
  title: string;
  topicsList: {
    path: string;
    blocks: Array<unknown>;
  };
  videos: {
    path: string;
    blocks: MixedTopicsType[];
  };
  metadata: LoggedOutHeaderData;
  hostname?: string;
};

export type LoggedOutLibraryData = {
  fullLibrary: LoggedOutFullLibraryData[];
  metadata: LoggedOutHeaderData;
  productsList: LoggedOutProduct[];
  topic: Record<string, unknown>;
  url: string;
  hostname?: string;
  success: number;
};

export type LoggedOutProductLibraryItem =
  | LoggedOutProductLibraryContainsItem
  | LoggedOutGroupedProductLibrary;

export type LoggedOutFullLibraryData = {
  navStructure: LoggedOutGroupedNavData[] | LoggedOutNavData[];
  product: LoggedOutProduct;
  productLibrary: LoggedOutProductLibraryItem[];
  productPath: string;
};

export type LoggedOutHeaderData = {
  descr: string;
  image?: string;
  title: string;
  type?: string;
};

export type LoggedOutNavData = {
  name: string;
  link: string;
  children: LoggedOutNavDataChildren[];
};

export type LoggedOutGroupedNavData = {
  groupName?: string;
  navs: LoggedOutNavData[];
  state?: string;
};

export type LoggedOutNavDataChildren = {
  name: string;
  icon: string;
  link: string;
};

export type LoggedOutProduct = {
  key: string;
  name: string;
};

export type LoggedOutProductLibraryContainsItem = {
  count?: number;
  icon?: string;
  id: string;
  name: string;
  path?: string;
  displayName?: string;
  type: string;
  contains?: LoggedOutProductLibraryContainsItem[];
  link?: string;
};

export type LoggedOutGroupedProductLibrary = {
  groupName: string;
  navs: LoggedOutProductLibraryContainsItem[];
  state?: string;
};

export type SelectedLibraryItem = {
  l1: LoggedOutProductLibraryContainsItem;
  l2: LoggedOutProductLibraryContainsItem;
};
